<template >
  <div class="calculator">
    <!-- <AuctionInfo :car_data="car_data" /> -->
    <div class="box">
      <div class="current-offer info">
        <span>AKTUALNA OFERTA</span>
        <span v-if="car_data['active_bidding'][0] != null"
          >{{ car_data["active_bidding"][0]["current_bid"] }}$</span
        >
      </div>
      <div class="auction-date info">
        <span>Zamknięcie oferty</span>
        <div>
          <span class="time-until" v-if="car_data['active_bidding'][0] != null">
            <img
              src="../assets/icons/clock.svg"
              class="icon"
              @click="selected.auction_name = ''"
            />
            {{ timeUntil(car_data["active_bidding"][0]["sale_date"]) }} </span
          ><br />
          <span class="time-until" v-if="car_data['active_bidding'][0] != null">
            <img
              src="../assets/icons/calandar.svg"
              class="icon"
              @click="selected.auction_name = ''"
            />
            {{ formatDate(car_data["active_bidding"][0]["sale_date"]) }}
          </span>
        </div>
      </div>
      <div class="bid-box">
        <div class="info">
          <p>Licytuj</p>
          <div class="bid-input">
            <input
              type="number"
              v-model="purchase_price"
              @change="getPriceCalculations"
            />
            $
          </div>
        </div>
        <button @click="redirectToContactPage" class="bid-button">
          Zleć Licytacje
        </button>
        <div class="info" v-if="car_data['est_retail_value'] != 0">
          <span class="small-text">Szacowana wartość rynkowa</span>
          <span class="price small-text"
            >{{ car_data["est_retail_value"] }}$</span
          >
        </div>
      </div>
    </div>
    <div class="box">
      <h3>Prognozowany koszt dostawy pod dom</h3>
      <div class="info bold">
        <span>Cena pod dom</span>
        <span class="price">{{ Math.round(data["total-price"]) }} PLN</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Kwota zakupu</span>
        <span class="price">{{ Math.round(purchase_price) }}$</span>
      </div>

      <hr class="divider" />

      <div class="info">
        <span>Miejsce dostawy</span>
        <span class="price">Warszawa/Mazowieckie</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Szacowany czas dostawy</span>
        <span class="price">{{
          formatDate(
            parseInt(car_data["active_bidding"][0]["sale_date"]) + 7889100000
          )
        }}</span>
      </div>
    </div>

    <div class="box">
      <h3>Kalkulator kosztów</h3>

      <hr class="divider" />
      <div class="info">
        <span>Koszty aukcyjne</span>
        <span class="price">{{ Math.round(data["auction"]) }}$</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Region pojazdu</span>
        <span class="price">{{ location }}</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Koszt transportu do portu w USA</span>
        <span class="price">{{ data["transport-to-port"] }}$</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Fracht morski do </span>

        <span class="price">{{ data["transport-to-ue"] }}$</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Broker</span>
        <span class="price">{{ data["broker"] }}$</span>
      </div>
      <hr class="divider" />

      <div class="info">
        <span><b>Cena bez odprawy celnej</b></span>
        <span class="price">{{ Math.round(data["price-to-ue"]) }}$</span>
      </div>
    </div>

    <div class="box">
      <h3>Kalkulator celny</h3>
      <!-- <div class="info">
        <span>Wartość pojazdu</span>
        <span class="price">{{ data["price-input_custom"] }} $</span>
      </div> -->
      <!-- <hr class="divider" /> -->
      <div class="info">
        <span>Typ pojazdu</span>
        <select
          name="vehicle"
          v-model="customs"
          class="options"
          @change="getPriceCalculations"
        >
          <option id="car" value="0.1">Samochód (10%)</option>
          <option id="motorcycle" value="0.06">Motocykl (6%)</option>
          <option id="yacht" value="0.017">Jacht (1.7%)</option>
          <option id="jet_ski" value="0.0170">Skuter wodny (1.7%)</option>
          <option id="quad" value="0.110">Quad (10%)</option>
        </select>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>Cło</span>
        <span class="price">{{ Math.round(data["duty"]) }}€</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span>VAT ({{ data["vat_procentage"] }}% - {{ ship_location }})</span>
        <select
          name="vehicle"
          v-model="ship_location"
          class="options"
          @change="getPriceCalculations"
        >
          <option id="Rotterdam" value="Rotterdam">Rotterdam,NL</option>
          <option id="Gdynia" value="Gdynia">Gdynia,PL</option>
          <option id="Bremerhaven" value="Bremerhaven">Bremerhaven,DE</option>
          <option id="Klaipeda" value="Klaipeda">Klaipeda, LT</option>
        </select>
        <span class="price">{{ Math.round(data["duty_vat"]) }}€</span>
      </div>
      <hr class="divider" />

      <div class="info">
        <span>Agencja celna i rozładunek</span>
        <span class="price">{{ data["service"] }}€</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <span><b>Koszt odprawy celnej</b></span>
        <span class="price">{{ Math.round(data["customs-cost"]) }}€</span>
      </div>
    </div>

    <div class="box">
      <h3>Transport i dodatkowe usługi</h3>
      <div class="info">
        <div class="checkbox">
          <input
            type="checkbox"
            v-model="to_home"
            @change="getPriceCalculations"
          />
          <span
            >Transport pod dom
            <p class="small_info">
              (w zależności od wielkości i stanu samochodu)
            </p>
          </span>
        </div>

        <span class="price">2400-2800 PLN</span>
      </div>
      <hr class="divider" />

      <div class="info">
        <div class="checkbox">
          <input
            type="checkbox"
            v-model="translation"
            @change="getPriceCalculations"
          />
          <span>Tłumaczenie dokumentów</span>
        </div>

        <span class="price">500 PLN</span>
      </div>
      <hr class="divider" />
      <div class="info">
        <div class="checkbox">
          <input
            type="checkbox"
            v-model="expertise"
            @change="getPriceCalculations"
          />
          <span>Opinia rzeczoznawcy</span>
        </div>

        <span class="price">500 PLN</span>
      </div>
      <hr class="divider" />

      <div class="info">
        <div class="checkbox">
          <input
            type="checkbox"
            v-model="report_excise"
            @change="getPriceCalculations"
          />
          <span>Zgłoszenie akcyzy</span>
        </div>

        <span class="price">180 PLN</span>
      </div>
      <hr class="divider" />

      <div class="info">
        <span>Prowizja (brutto)</span>
        <span class="price">4000 PLN</span>
      </div>
    </div>
    <div class="box">
      <div class="info final_cost">
        <span class="txt">CENA POD DOM</span>
        <span class="total-price"
          >{{ Math.round(data["total-price"]) }} PLN</span
        >
      </div>
      <span class="small">
        Wartości w kalkulatorze są kosztami orientacyjnymi. Mogą ulec zmianie.
        <br />O dokładne koszty zapytaj importera.
      </span>
      <div class="cta">
        <p>CHCESZ OTRZYMAĆ SZCZEGÓŁOWĄ WYCENĘ?</p>
        <a href="https://amerykacars.pl/kontakt/">SKONTAKTUJ SIĘ</a>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import AuctionInfo from "@/components/AuctionInfo.vue";

export default {
  name: "Calculator",
  props: ["car_data"],
  data() {
    return {
      purchase_price: 0,
      location: this.car_data["location"],
      to_home: false,
      translation: false,
      customs: "0.1",
      ship_location: "Rotterdam",
      expertise: false,
      data: {
        auction: 0,
        "transport-to-port": 0,
        "transport-to-ue": 0,
        broker: 0,
        "price-to-ue": 0,
        "price-input_custom": 0,
        duty: 0,
        duty_vat: 0,
        service: 0,
        "customs-cost": 0,
        "total-price": 0,
      },
      report_excise: false,
    };
  },
  mounted() {
    if (this.car_data["active_bidding"][0] != null) {
      this.purchase_price = this.car_data["active_bidding"][0]["current_bid"];
    }
    this.getPriceCalculations();
  },
  components: {
    AuctionInfo,
  },
  methods: {
    async getPriceCalculations() {
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-price-calculation",
        {
          lot_price: this.purchase_price ?? 0,
          location: this.location,
          to_home: this.to_home,
          translation: this.translation,
          expertise: this.expertise,
          customs: this.customs,
          report_excise: this.report_excise,
          ship_to: this.ship_location,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      this.data = data;
      console.log("get_price_calculations");
      console.log(this.data)
    },
    redirectToContactPage() {
      window.top.location.href = `https://amerykacars.pl/kontakt`;
    },
    formatDate(unixTimestamp) {
      // Przekształcenie timestampu w milisekundy
      if (unixTimestamp == null) {
        return "Brak daty";
      } else {
        const date = new Date(unixTimestamp * 1);

        // Uzyskanie elementów daty
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Miesiące są od 0 do 11, więc dodajemy 1
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        // Formatowanie daty
        return `${day}-${month}-${year} ${hours}:${minutes}`;
      }
    },
    timeUntil(unixTimestamp) {
      const now = new Date().valueOf(); // Aktualny czas w milisekundach
      const targetTime = new Date(unixTimestamp * 1).valueOf(); // Przekształcenie Unix Timestamp na milisekundy
      console.log(now);
      console.log(targetTime);
      const difference = targetTime - now;

      if (difference <= 0) {
        return "Aukcja sie zakończyła";
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );

        return `${days} dni, ${hours} godzin, ${minutes} minut`;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.calculator {
  display: flex;
  flex-direction: column;
  gap: 30px;
  background-color: #edf2f7;
}
.box {
  background-color: white;
  padding: 20px 30px;
}
.final_cost {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.price-input {
  height: 8px;
}
.options {
  border: 2px solid #edf2f7;
  padding: 7px;
  font-size: 10px;
  width: 120px;
}
.final_cost {
  padding: 20px 0px;
}

/* to span with text 'RAZEM'  add class 'txt'  */
.final_cost span.txt {
  font-family: "bicyclette";
  font-size: 18px !important;
  font-weight: 100 !important;
}
.total-price {
  font-size: 30px !important;
  font-weight: bold;
  color: #011f68;
}
.cta {
  flex-direction: column;
  padding: 18px 30px 24px;
  background: #be1e2d;
  margin-top: 19px;
  display: flex;
  align-items: center;
}
.cta p {
  font-family: "bicyclette";
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  text-align: center;
  margin: 0 0 20px;
  color: #fff;
}
.cta a {
  padding: 8px 9px;
  font-family: "bicyclette";
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  text-align: center;
  text-decoration: none;
  background: #ffffff;
  color: #be1e2d;
}

/*  */

/* remove style 'height' from .calculator .box, .box1, .box2, .box3, .box4 */
.calculator h3 {
  font-family: "bicyclette";
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
  color: #011f68;
}

.calculator .box .info {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.divider {
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1.8px #edf2f7 solid;
}
.calculator .box .info span {
  font-family: "bicyclette";
  font-size: 15px;
  font-weight: 400;
  line-height: 19.5px;
  color: #011f68;
}
.calculator .box .info span.price {
  font-family: "bicyclette";
  font-size: 15px;
  font-weight: 700;
  line-height: 19.5px;
  color: #011f68;
}
.calculator .box .info input[type="number"] {
  border: 2px solid #edf2f7;
  padding: 9px 0px;
  text-align: center;
  width: 120px;
}
.calculator .box .info input[type="number"] {
  border: 2px solid #edf2f7;
  padding: 9px;
  text-align: center;
  width: 150px;
}
.calculator .box .info .checkbox {
  font-family: "bicyclette";
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  color: #011f68;
}

.current-offer,
.bid-box {
  padding: 20px;
  margin: 12px 0px !important;

  background-color: #edf2f7;
}
.current-offer span {
  font-size: 18px !important;
  font-weight: bold;
}
.bid-input {
  display: flex;
  align-items: center;
}
.bid-input input {
  width: 70px !important;
}
.bid-box span {
  display: block;
  font-size: 11px;
}
.bid-button {
  display: block;
  width: 100%;
  padding: 10px;
  margin-top: 12px;
  text-align: center;
  margin-bottom: 5px;
  color: white;
  border: none;
  background-color: #018e42;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
}
.info.bold span {
  font-weight: bold !important;
  font-size: 16px !important;
}
.time-until {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #011f68;
}
.small {
  font-size: 14px;
}
</style>
